import React from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon, YoutubeIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/oaQANTmLmdH94jWkAeshbq/LetLois_Logo_Wide_Lapels_Blue_Transparent_(1).png';
interface FooterColumn {
  title: string;
  links: string[];
}
const COLUMNS: FooterColumn[] = [{
  title: 'Services',
  links: ['Consulting', 'Google Ads', 'Meta Ads', 'Websites', 'GHL Setup']
}, {
  title: 'Pages',
  links: ['Home', 'About', 'Pricing', 'Contact']
}, {
  title: 'Legal',
  links: ['Privacy Policy', 'Cookie Policy', 'Terms of Use']
}, {
  title: 'Contact',
  links: ['Gilbert, AZ', 'Book a call', 'GoHighLevel partner']
}];
const SOCIAL_LINKS = [{
  label: 'Instagram',
  href: '#',
  icon: InstagramIcon
}, {
  label: 'Facebook',
  href: 'https://www.facebook.com/profile.php?id=100095138157807',
  icon: FacebookIcon
}, {
  label: 'YouTube',
  href: 'https://www.youtube.com/@EofApod',
  icon: YoutubeIcon
}, {
  label: 'LinkedIn',
  href: 'https://www.linkedin.com/company/letlois/?viewAsMember=true',
  icon: LinkedinIcon
}];
export function Footer() {
  return <footer className="w-full bg-black text-white" data-id="element-104" data-mp="3gapd7j63ckfz">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-20" data-id="element-105" data-mp="3gca7d7ohu1db">
        <div className="grid gap-14 lg:grid-cols-[1.35fr_3fr] lg:gap-20" data-id="element-106" data-mp="3v8rgrtd4h5x8">
          <div data-id="element-107" data-mp="3q8wts0wgx0hg">
            <a href="#" className="flex items-center" aria-label="LetLois home" data-id="element-108" data-mp="3q8dhp0ti16bc">
              <img src={LOGO_URL} alt="LetLois" className="h-10 w-auto max-w-[170px] object-contain object-left" data-id="element-109" data-mp="82ienymgqkhh" />
            </a>
            <p className="mt-4 max-w-xs font-mono-eyebrow text-[10px] font-semibold uppercase leading-relaxed tracking-[0.16em] text-brand-blue" data-id="element-110" data-mp="335slg3f1hfy">
              // Websites, ads & consulting for med spas and home services.
            </p>
            <div className="mt-7 flex gap-3" aria-label="Social media" data-id="element-111" data-mp="cw33p162w44j">
              {SOCIAL_LINKS.map(({
              label,
              href,
              icon: Icon
            }) => <a key={label} href={href} target={href === '#' ? undefined : '_blank'} rel={href === '#' ? undefined : 'noreferrer'} aria-label={label} className="flex h-10 w-10 items-center justify-center border border-brand-blue/70 text-white transition-colors hover:bg-brand-blue hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue" data-id="element-112" data-mp="mspnrnqkyr5i">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-113" data-mp="1cmdwkaf3nqw2" />
                </a>)}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-x-8 gap-y-12 sm:grid-cols-4" data-id="element-114" data-mp="1hj4bguf64gfw">
            {COLUMNS.map(column => <div key={column.title} data-id="element-115" data-mp="1mhpaiqioou2r">
                <h3 className="font-mono-eyebrow text-[10px] font-semibold uppercase tracking-[0.18em] text-brand-blue" data-id="element-116" data-mp="1rjemq9hn7dsf">
                  {column.title}
                </h3>
                <ul className="mt-6 space-y-3" data-id="element-117" data-mp="3ta8bnndit7d3">
                  {column.links.map(link => <li key={link} data-id="element-118" data-mp="2af3t5raxr5k5">
                      <a href="#" className="text-sm text-white/55 transition-colors hover:text-white focus:outline-none focus-visible:text-brand-blue" data-id="element-119" data-mp="2ag5f4qthpcgn">
                        {link}
                      </a>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-7 sm:flex-row sm:items-center" data-id="element-120" data-mp="1wpjr6np6icbw">
          <p className="font-mono-eyebrow text-[10px] uppercase tracking-[0.1em] text-white/30" data-id="element-121" data-mp="2pcnumo8miilk">© {new Date().getFullYear()} LetLois LLC. All rights reserved.</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2" data-id="element-122" data-mp="2kfe75e4soh0d">
            {['Privacy Policy', 'Cookie Policy', 'Terms of Use'].map(link => <a key={link} href="#" className="font-mono-eyebrow text-[10px] uppercase tracking-[0.1em] text-white/30 transition-colors hover:text-white" data-id="element-123" data-mp="18ynx1jx9351h">
                {link}
              </a>)}
          </div>
        </div>
      </div>
    </footer>;
}